import type { FeatureZoomOverride } from "./featureZoomOverrideTypes";

// Per-part zoom overrides for visualizerType "Kitchen" — see the shape/unit docs in
// ../featureGroupZoomDefaults.ts (getFeatureZoomOverride). Bulk-ported (2026-08-15) from
// scss/bv/responsive-canvas-kitchen.scss's per-part `scale(X)` values. Seeded even though Kitchen
// isn't on the docked canvas yet, so it's ready if/when that type moves over.
export function getKitchenFeatureZoomOverride(partId: string): FeatureZoomOverride | undefined {
  switch (partId) {
    case "backsplash":
    case "bottom_handle":
    case "center_island_handle":
    case "center_island_sink":
    case "fridge":
    case "top_cabinet":
      return { scale: 1.3 };
    case "center_island_edge":
    case "crown_molding":
    case "hood":
    case "microwave":
    case "peninsula":
    case "range":
    case "sink":
    case "top_handle":
      return { scale: 1.5 };
    case "center_island_faucet":
    case "faucet":
      return { scale: 2.5 };
    case "countertop":
    case "edge_profile":
      return { scale: 1.4 };
    case "dishwasher":
      return { scale: 1.7 };
    default:
      return undefined;
  }
}
